<template>
  
  <div>
    <div id="reptree-container" :key="treeTrigger">
      <div v-for="branch in treeDisplay" v-bind:key="branch.index" class="movelist-row"
              :class="{ indent0 : branch.indentLevel == 0 ,
                indent2 : branch.indentLevel == 1,
                indent4 : branch.indentLevel == 2,
                indent6 : branch.indentLevel == 3,
                indent8 : branch.indentLevel == 4,
                indent10 : branch.indentLevel == 5,
                indent12 : branch.indentLevel == 6,
                indent14 : branch.indentLevel == 7,
              }"
        >
          <span v-for="branchElement in branch.moves" v-bind:key="branchElement.index">
            <span v-if="branchElement.ply >= 0 && (branchElement.ply % 2 == 0 || branchElement.parentIsOpen)">
              <span v-if="branchElement.ply % 2 == 0">
                {{ branchElement.ply/2 + 1 }}.
              </span>
              <span v-if="branchElement.ply % 2 == 1">
                {{ (branchElement.ply-1)/2 + 1 }}...
              </span>
            </span>

            <span @click="onMoveClick(branchElement)"  :class="{
                  'reptree-selected-text-dark' : branchElement.selected && isDark,
                  'reptree-move-text-dark'     : !branchElement.selected && isDark,
                  'reptree-selected-text-light' : branchElement.selected && !isDark,
                  'reptree-move-text-light'     : !branchElement.selected  && !isDark,
                  'reptree-text-bold' : branchElement.move.first_move_not_addressed > 0,
                  'reptree-text-italic' : branchElement.move.first_move_not_addressed == 0 && branchElement.move.percent > 0,
                  'reptree-text-regular' : branchElement.move.first_move_not_addressed == 0 && branchElement.move.percent == 0
                }">
              {{branchElement.move.san}}

              <i v-if="showComments && branchElement.move.comment != ''" class="reptree-move-comment">{{  "{ " + branchElement.move.comment + " }" }}</i>
            </span>
          
            <span v-if="branchElement.move.canBranchAfterThisMove && branchElement.move.branchIsOpen" 
                          :class="{
                              'branch-opener-dark' : isDark,
                              'branch-opener-light': !isDark
                          }"
                          @click="onBranchClick(branchElement)">
              (-)
            </span>
            <span v-if="branchElement.move.canBranchAfterThisMove && !branchElement.move.branchIsOpen" 
                          :class="{
                              'branch-opener-dark' : isDark,
                              'branch-opener-light': !isDark
                          }"
                          @click="onBranchClick(branchElement)">
              (+)
            </span>
            &nbsp;
          </span>
        </div>
      </div>
    </div>
 </template>
 
 <script setup>
 
 import { useConnectionStore } from '@/stores/connectionStore';
  
 import { reactive, onMounted, ref } from "vue";
 import { watch } from 'vue'
 import { computed } from "@vue/reactivity"
  
 const emit = defineEmits(['move-click','branch-click'])
 
 const props = defineProps({
   treeDisplay : {
       type : Array,
       default : []
   },
   treeTrigger : {
       type : Number,
       default : 0
   },
   showComments : {
    type : Boolean,
    default : false
  }
 })
 
 const connectionStore = useConnectionStore()
 const isDark = ref(connectionStore.getDarkmode != "light")
 
 const treeDisplay = computed({ get() { return props.treeDisplay }})
 const treeTrigger = computed({ get() { return props.treeTrigger }})
 const showComments = computed({ get() { return props.showComments }})

 watch(treeTrigger, (newVal,oldVal) => {
   //console.log("in watch tree trigger count ",newVal)
   //console.log(treeDisplay)
  })
 
  watch(showComments, (newVal,oldVal) => {
    //console.log("Show comments",newVal)
  })

 onMounted(() => {
   })
 
  function onMoveClick(branchElement) {
    //console.log("****** move click ",branchElement)
    emit('move-click',branchElement)
  }

  function onBranchClick(branchElement) {
    //console.log("****** branch click ",branchElement)
    emit('branch-click',branchElement)
  }

 </script>
 
 <style scoped>

.branch-opener-dark {
  color : yellow;
  font-weight: bold;
}

.branch-opener-light {
  color : black;
  font-weight: bold;
}

.movelist-row {
  line-height: 1.5em;
  border-bottom: slategray dotted 1px;
  /*border-bottom: #286a6c solid 1px;*/
}

.reptree-text-bold {
  font-weight: bold;
}
.reptree-text-regular {
  font-weight: normal;
}
.reptree-text-italic {
  font-style: italic;
}
.reptree-move-text-light {
  color : rgb(13,110,253)
}
.reptree-move-text-dark {
  color : #fff;
}
.reptree-selected-text-light {
  color : blue;
  background : yellow;
  padding: 2px;
  border : solid 1px black;
  border-radius: 3px;
}

.reptree-selected-text-dark {
  color : #fff;
  background : gray;
  padding: 2px;
  border : solid 1px #fff;
  border-radius: 3px;
}

.reptree-move-comment {
  font-style: italic;
  font-size: .9em;
}

.md-20 {
  font-size : 20px;
}

.md-25 {
  font-size : 25px;
}

.md-30 {
  font-size : 30px;
}

.md-40 {
  font-size : 40px;
}

.material-symbols-outlined {
  vertical-align: middle;
  font-variation-settings:
  'FILL' 0,
  'wght' 400,
  'GRAD' 0,
  'opsz' 24
}
 
.indent0 {
  margin-left: 1em;
  text-indent:-1em;
}
.indent1 {
  margin-left: 2em;
  text-indent:-1em;
}

.indent2 {
  margin-left: 3em;
  text-indent:-1em;
}

.indent3 {
  margin-left: 4em;
  text-indent:-1em;
}
.indent4 {
  margin-left: 5em;
  text-indent:-1em;
}

.indent5 {
  margin-left: 6em;
  text-indent:-1em;
}

.indent6 {
  margin-left: 7em;
  text-indent:-1em;
}

.indent7 {
  margin-left: 8em;
  text-indent:-1em;
}

.indent8 {
  margin-left: 8em;
  text-indent:-1em;
}
.indent9 {
  margin-left: 8em;
  text-indent:-1em;
}
.indent10 {
  margin-left: 8em;
  text-indent:-1em;
}

 </style>